import { MutationTree } from 'vuex';
import { DexUserInfo, DexUserState } from './state';

const mutations: MutationTree<DexUserState> = {
  SET_DEX_USER(state, payload: { dexUser: DexUserInfo }): void {
    state.dexUser = payload.dexUser;
  },
};

export default mutations;
